import globalAxios from 'axios';

export type LoginBasicPostType = {
  username: string;
  password: string;
};

export type LoginResponseType = {
  token: string;
};

export const LoginApi = () => ({
  // Uses global axios (not axiosInstance) – login must work without auth token
  basicLogin: (data: LoginBasicPostType) =>
    globalAxios.post<LoginResponseType>(
      `${process.env.REACT_APP_ROOT_API}/users/login_basic/`,
      data,
      { headers: { Accept: 'application/json' } }
    ),

  // Kerberos uses fetch because it needs credentials: 'include' (NTLM/Negotiate)
  kerberosLogin: () =>
    fetch(`${process.env.REACT_APP_ROOT_API}/login_kerberos/`, {
      method: 'POST',
      credentials: 'include'
    })
});
